import { WidgetType } from '../base'
import { WidgetRowFactory } from '../base/row/WidgetRowFactory'
import { WidgetService } from '../base/widget/WidgetService'
import { WidgetContainer } from './WidgetContainerInterface'

export default class WidgetContainerFactory {
  public static create(): WidgetContainer {
    const container = JSON.parse(JSON.stringify(WidgetService.getWidgetSpecification(WidgetType.widgetContainer)))
    container.rows = [WidgetRowFactory.createEmpty()]
    return container as WidgetContainer
  }
}
